export default "__VITE_ASSET__8583f24f__"